import { EntityTypeSelect } from "@/components/selects";
import { Typography } from "@mui/material";
import { Create, PasswordInput, SimpleForm, TextInput } from "react-admin";

const EntityCreate = () => {
  return (
    <Create>
      <SimpleForm>
        {/* Entity Information */}
        <Typography variant="h6" gutterBottom>
          Informations de l'entité
        </Typography>
        <TextInput source="name" label="Nom de l'entité" />
        <TextInput source="pseudo" label="Pseudo  de l'entité" />
        <EntityTypeSelect source="type" />

        {/* User Information */}
        <Typography variant="h6" gutterBottom>
          Informations de l'utilisateur
        </Typography>
        <TextInput
          source="user.full_name"
          label="Nom complet de l'utilisateur"
        />
        <TextInput source="user.email" label="Email de l'utilisateur" />
        <TextInput source="user.pseudo" label="Pseudo de l'utilisateur" />
        <PasswordInput
          source="user.password"
          label="Mot de passe de l'utilisateur"
        />
        <TextInput
          type="numeric"
          source="user.role"
          defaultValue="2"
          sx={{ display: "none" }}
        />
      </SimpleForm>
    </Create>
  );
};
export default EntityCreate;
